/* What a tile says about one entry of the catalogue.

   A lesson and an old worked example are drawn by the same tile, and the two
   have different things to say under the title. An example says what it is —
   the sentence about how it was made. A lesson says where the pupil ends up,
   because that is what a teacher scans a grid of sixty tiles for; the goal at
   the expected level is in the index for exactly this reason.

   The second line is the honest one. A lesson carries ten materials or says
   how many of them are actually finished — PLAN.md, "Čemu je třeba se vyhnout":
   a lesson that is not filled has it written on its tile and does not pretend.
   A filled lesson says nothing, because "10 z 10" on every tile is noise, and
   an old example says nothing either, since it has no kit to be short of.

   OWNED BY ITEM 11 OF PLAN.md. */

import { useI18n } from "../../lib/i18n";
import { KIT_KINDS } from "../../lib/types";
import type { IndexEntry, Localized } from "../../lib/types";

/* The line under the title: where the pupil ends up, or what the material is. */
export function tileSub(entry: IndexEntry): Localized | undefined {
  return entry.goal ?? entry.claim;
}

export function TileFoot({ entry }: { entry: IndexEntry }) {
  const { ui } = useI18n();
  const filled = entry.filled;
  return (
    <>
      {/* Every material in the catalogue is a lesson. It said so by ruling out
          the three shapes an old example could have; the shapes are gone with
          the examples, so it says it outright. */}
      {ui("catalog.lesson")}
      {typeof filled === "number" && filled < KIT_KINDS.length ? (
        <span className="tile-filled">
          {filled} / {KIT_KINDS.length} {ui("lesson.filled")}
        </span>
      ) : null}
    </>
  );
}
